import { styled, Box, Typography } from "@mui/material";
import { dumontColors } from "../../../colors";

export const Container = styled(Box)({
  width: "389px",
  display: "flex",
  flexDirection: "column",
});

export const TitleContainer = styled(Box)({
  padding: "0px 8px",
  height: "18.19px",
  display: "flex",
  alignItems: "center",
});

export const TitleText = styled(Typography)({
  fontFamily: "Manrope",
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: "1.4em",
  color: dumontColors.textTertiary,
  textAlign: "left",
});

export const CardsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginTop: "8px",
});

export const PromptCard = styled(Box)<{ isSelected: boolean }>(({ isSelected }) => ({
  width: "389px",
  height: "68.39px",
  padding: "12px 0px 12px 16px",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  border: isSelected ? `1px solid ${dumontColors.primary}` : `1px solid ${dumontColors.border}`,
  borderRadius: "8px",
  cursor: "pointer",
  boxSizing: "border-box",
  backgroundColor: isSelected ? dumontColors.primaryLight : "transparent",
  boxShadow: isSelected ? `0px 2px 8px 0px ${dumontColors.shadow}` : "none",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: isSelected ? dumontColors.primaryLight : dumontColors.backgroundHover,
    borderColor: dumontColors.primary,
  },
  "&:not(:first-of-type)": {
    marginTop: "8px",
  },
}));

export const CardTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "stretch",
});

export const CardTitle = styled(Typography)({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "1.4em",
  color: dumontColors.text,
  textAlign: "left",
});

export const CardDescriptionContainer = styled(Box)({
  width: "355px",
  height: "16.8px",
});

export const CardDescription = styled(Typography)({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "1.4em",
  color: dumontColors.textTertiary,
  textAlign: "left",
});
